import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceWorkTypeProjectLimitRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-work-type-project-limit',
	path: '/jira/settings/system/performance/metrics/worktype/projectlimit',
};
